/**
 * Health status values returned by /health API endpoint (API Server).
 *
 * Shared by JobRunDetail and SystemHealth screens. Do not duplicate — use this file.
 */
export enum ComponentHealthStatus {
  HEALTHY = 'healthy',
  DEGRADED = 'degraded',
  UNHEALTHY = 'unhealthy',
  NOT_MONITORED = 'not_monitored',
  UNKNOWN = 'unknown',
}
